export enum CheckboxAlignEnum {
  Top = 'top',
  Bottom = 'bottom',
}
